import { PropsWithChildren } from 'react';

export function ModalFooter(props: PropsWithChildren) {
  return (
    <div className="mt-2 flex flex-row justify-between">{props.children}</div>
  );
}
